import { Container, Point } from 'pixi.js';
import { MonoBehavior } from '../core/monoBehavior';
import { addToLevel } from '../core/Playable2DRootContainer';
import { GameEvent } from '../events/gameEvent';
import { EventName } from '../events/eventsName';
import { Layout } from '../LayoutManager';
import gsap, { Power1 } from 'gsap';
import { CARD_MOVE_TIME, MENU_TRANSITION_TIME } from 'constants/move';
import { Displays, DESKTOP_SIDEBAR_WIDTH, DESKTOP_UI_WIDTH, BUTTONS_BOTTOM_MARGIN_DESKTOP } from 'constants/layout';

export class GameActionButton extends MonoBehavior {
    disabled: boolean;
    settingsOpen = false;
    blockMove = 0;
    index: number;
    button: Container;

    constructor(icon: string, index: number) {
        super();
        this.index = index;
        this.action = this.action.bind(this);
        this.getStoreCounter = this.getStoreCounter.bind(this);
        this.setDisabled = this.setDisabled.bind(this);
        this.blockButton = this.blockButton.bind(this);
        this.onOpenSettings = this.onOpenSettings.bind(this);
        this.onCloseSettings = this.onCloseSettings.bind(this);
        this.button = new Container();

        this.disabled = true;

        GameEvent.add(EventName.BLOCK_ACTION_BUTTONS, this.blockButton);
        GameEvent.add(EventName.OPEN_SETTINGS, this.onOpenSettings);
        GameEvent.add(EventName.HIDE_SETTINGS, this.onCloseSettings);
        GameEvent.add(EventName.ADS_CLOSED, () => {
            this.blockButton(0);
        });
        GameEvent.add(EventName.START_TUTORIAL, this.onTutorialChange.bind(this, true));
        GameEvent.add(EventName.STOP_TUTORIAL, this.onTutorialChange.bind(this, false));
    }
    getStoreCounter() {
        console.warn('getStoreCounter not implemented for', this.constructor.name);
        return 0;
    }
    blockButton(blockTime: number) {
        this.blockMove = performance.now() + blockTime;
    }

    start(): void {
        addToLevel(this.button);
        this.button.zIndex = 10;
    }
    onClick() {}
    action() {
        if (this.blockMove > performance.now()) return;
        if (this.disabled) return;

        this.blockButton(Infinity);
        this.onClick();
    }

    setDisabled(disabled: boolean) {
        this.disabled = disabled;
    }

    resize(width: number, height: number): void {
        const display = Layout.getDisplay();
        const position = new Point();
        const padding = Layout.getButtonPadding();
        const buttonSize = Layout.getButtonSize();
        switch (display) {
            case Displays.MOBILE:
            case Displays.TABLET:
                position.set(
                    width / 2 - buttonSize * (this.index + 0.5) - padding.x * (this.index + 1),
                    height / 2 - buttonSize / 2 - padding.y
                );
                break;
            case Displays.DESKTOP:
                position.set(
                    -DESKTOP_SIDEBAR_WIDTH / 2 + (this.index - 1) * -1 * (buttonSize + padding.x),
                    height / 2 - buttonSize * 0.5 - BUTTONS_BOTTOM_MARGIN_DESKTOP
                );
                break;
        }
        this.button.position = position;
        // this.updateCounter();
    }

    onOpenSettings() {
        const display = Layout.getDisplay();
        const padding = Layout.getButtonPadding();

        const buttonSize = Layout.getButtonSize();

        if (display === Displays.DESKTOP) {
            gsap.to(this.button.position, {
                x: -DESKTOP_UI_WIDTH / 2 + (this.index - 1) * -1 * (buttonSize + padding.x),
                ease: Power1.easeOut,
                duration: CARD_MOVE_TIME,
            });
        }
    }
    onCloseSettings() {
        const display = Layout.getDisplay();
        const padding = Layout.getButtonPadding();

        const buttonSize = Layout.getButtonSize();

        if (display === Displays.DESKTOP) {
            gsap.to(this.button.position, {
                x: -DESKTOP_SIDEBAR_WIDTH / 2 + (this.index - 1) * -1 * (buttonSize + padding.x),
                ease: Power1.easeOut,
                duration: CARD_MOVE_TIME,
            });
        }
    }

    hideButtons() {
        gsap.to(this.button, { alpha: 0, ease: Power1.easeInOut, duration: MENU_TRANSITION_TIME });
    }
    showButtons() {
        gsap.to(this.button, { alpha: 1, ease: Power1.easeInOut, duration: MENU_TRANSITION_TIME });
    }

    onTutorialChange(isStarted: boolean) {
        if (isStarted) {
            this.hideButtons();
            this.setDisabled(true);
        } else {
            this.setDisabled(false);
            this.showButtons();
        }
    }
}
